import React, { useEffect, useState } from "react";
import { bool, shape, string } from "prop-types";
import QRCode from "react-qr-code";
import bankIdImage from "../../../assets/images/bankid.svg";
import Loader from "../loader/loader";
import Button from "../button/button";
import { Trans } from "react-i18next";

const BankId = ({
  size,
  forceShow,
  bankIdInfo: { desktopAppLink, qrLink, bankIdMessage, status },
}) => {
  const [desktopSignInMode, setDesktopSignInMode] = useState(false);

  const showQRCode = status !== "failed" && !desktopSignInMode;
  const showOpenDesktopButton =
    status !== "failed" && desktopAppLink && !desktopSignInMode;

  useEffect(() => {
    if (typeof status !== "string") setDesktopSignInMode(false);
  }, [status]);

  if (!bankIdMessage && !forceShow) {
    return null;
  }

  const onClickOpenDesktopApp = () => {
    setDesktopSignInMode(true);
    window.location = desktopAppLink;
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <img src={bankIdImage} alt="bankid logo" style={{ width: size }} />
      {bankIdMessage && (
        <div className="max-w-[500px] p-8 text-center font-semibold">
          <Trans i18nKey={bankIdMessage} />
        </div>
      )}
      {showQRCode && (
        <div className="rounded-xl bg-background p-4 shadow">
          {qrLink ? (
            <QRCode
              value={qrLink}
              level="L"
              size={180}
              style={{
                height: "auto",
                maxWidth: "100%",
                width: "100%",
                background: "white",
              }}
              viewBox="0 0 180 180"
            />
          ) : (
            <Loader />
          )}
        </div>
      )}
      {showOpenDesktopButton && (
        <Button
          onClick={onClickOpenDesktopApp}
          tid="credentials_signin_bankid.open_on_this_device"
        />
      )}
    </div>
  );
};

BankId.propTypes = {
  bankIdInfo: shape({
    orderRef: string,
    desktopAppLink: string,
    qrLink: string,
    bankIdMessage: string,
    status: string,
  }),
  size: string,
  forceShow: bool,
};

BankId.defaultProps = {
  bankIdInfo: {},
  size: "50px",
};

export default BankId;
